import React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    fontSize?: string;
    offer: {
        buildings: number;
        currency: Currency;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        name: string;
        properties: number;
        stats: {
            all_flat_types: Record<string, number>;
            properties_count_for_sale: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
        } | null;
        type: number;
    };
}

export const OfferGeneratedDescriptionTextFlats: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;
    const fontSize = props.fontSize ? props.fontSize : "fs16";

    const isApartment = offer.is_holiday_location || offer.is_condohotel;
    const futureEndDate = isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(offer.construction_date_range.lower));
    const upper = formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego", "nowych", "nowych"]);
    // flats
    const flatsWhoPlural = pluralize(["nowe mieszkanie", "nowe mieszkania", "nowych mieszkań"]);
    const flatsWhomPlural = pluralize(["mieszkania", "mieszkań", "mieszkań"]);
    // apartments
    const apartmentsWhoPlural = pluralize(["nowy apartament", "nowe apartamenty", "nowych apartamentów"]);
    const apartmentsWhomPlural = pluralize(["apartamentu", "apartamentów", "apartamentów"]);
    // others
    const buildingsPlural = pluralize(["budynku", "budynkach", "budynkach"]);
    const buildingsOwnsPlural = pluralize(["Budynek posiada", "Budynki posiadają", "Budynki posiadają"]);
    const floorsAboveGroundPlural = pluralize(["kondygnację naziemną", "kondygnacje naziemne", "kondygnacji naziemnych"]);
    const floorsBelowGroundPlural = pluralize(["kondygnację podziemną", "kondygnacje podziemne", "kondygnacji podziemnych"]);
    const noFloorsBelowGroundPlural = pluralize(["posiada", "posiadają", "posiadają"]);
    const arePlural = pluralize(["jest", "są", "jest"]);

    return (
        <>
            <p>
                {` ${
                    futureEndDate || !upper
                        ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                              upper ? `z planowanym na ${upper} roku terminem oddania do użytkowania` : ""
                          }`
                        : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper ? `w ${upper} roku` : ""}`
                }.`}
            </p>

            {offer.properties && offer.floors_above_ground_range && (
                <p className={fontSize}>
                    {`Cały projekt składa się z ${
                        offer.properties
                            ? ` ${offer.properties} ${propertiesPlural(offer.properties)}

                        ${isApartment ? `${apartmentsWhomPlural(offer.properties)}` : `${flatsWhomPlural(offer.properties)}`}`
                            : ""
                    } znajdujących się w ${offer.buildings} ${buildingsPlural(offer.buildings)}. ${buildingsOwnsPlural(offer.buildings)} ${
                        offer.floors_above_ground_range.lower === offer.floors_above_ground_range.upper
                            ? `${offer.floors_above_ground_range.upper} ${floorsAboveGroundPlural(offer.floors_above_ground_range.upper)}`
                            : `od ${offer.floors_above_ground_range.lower} do ${offer.floors_above_ground_range.upper} kondygnacji naziemnych`
                    } wraz z parterem oraz ${
                        offer.floors_below_ground
                            ? `${offer.floors_below_ground} ${floorsBelowGroundPlural(offer.floors_below_ground)}`
                            : `nie ${noFloorsBelowGroundPlural(offer.buildings)} kondygnacji podziemnych`
                    }.`}
                </p>
            )}

            <p>
                {offer.stats?.properties_count_for_sale ? (
                    <>
                        {`Aktualnie w inwestycji ${offer.name} w sprzedaży ${arePlural(offer.stats.properties_count_for_sale)} ${
                            offer.stats.properties_count_for_sale
                        } ${isApartment ? apartmentsWhoPlural(offer.stats.properties_count_for_sale) : flatsWhoPlural(offer.stats.properties_count_for_sale)} ${
                            !!offer.stats.ranges_area_min
                                ? ` o powierzchni${
                                      offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                          ? ` ${offer.stats.ranges_area_min}`
                                          : ` od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                                  } metrów kwadratowych`
                                : ""
                        }${offer.stats.ranges_price_m2_min ? `, w cenie od ${numberFormat(offer.stats.ranges_price_m2_min)} ${getCurrency({currency: props.offer.currency})} za metr kwadratowy` : ""}.`}
                    </>
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych mieszkań w sprzedaży.</>
                )}
            </p>
        </>
    );
};
import React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    fontSize?: string;
    offer: {
        buildings: number;
        currency: Currency;
        construction_date_range: IRangeQuery<string>;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        name: string;
        properties: number;
        stats: {
            all_flat_types: Record<string, number>;
            properties_count_for_sale: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
        } | null;
        type: number;
    };
}

export const OfferGeneratedDescriptionTextFlats: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;
    const fontSize = props.fontSize ? props.fontSize : "fs16";

    const isApartment = offer.is_holiday_location || offer.is_condohotel;
    const futureEndDate = isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(offer.construction_date_range.lower));
    const upper = formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego", "nowych", "nowych"]);
    // flats
    const flatsWhoPlural = pluralize(["nowe mieszkanie", "nowe mieszkania", "nowych mieszkań"]);
    const flatsWhomPlural = pluralize(["mieszkania", "mieszkań", "mieszkań"]);
    // apartments
    const apartmentsWhoPlural = pluralize(["nowy apartament", "nowe apartamenty", "nowych apartamentów"]);
    const apartmentsWhomPlural = pluralize(["apartamentu", "apartamentów", "apartamentów"]);
    // others
    const buildingsPlural = pluralize(["budynku", "budynkach", "budynkach"]);
    const buildingsOwnsPlural = pluralize(["Budynek posiada", "Budynki posiadają", "Budynki posiadają"]);
    const floorsAboveGroundPlural = pluralize(["kondygnację naziemną", "kondygnacje naziemne", "kondygnacji naziemnych"]);
    const floorsBelowGroundPlural = pluralize(["kondygnację podziemną", "kondygnacje podziemne", "kondygnacji podziemnych"]);
    const noFloorsBelowGroundPlural = pluralize(["posiada", "posiadają", "posiadają"]);
    const arePlural = pluralize(["jest", "są", "jest"]);

    return (
        <>
            <p>
                {` ${
                    futureEndDate || !upper
                        ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                              upper ? `z planowanym na ${upper} roku terminem oddania do użytkowania` : ""
                          }`
                        : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper ? `w ${upper} roku` : ""}`
                }.`}
            </p>

            {offer.properties && offer.floors_above_ground_range && (
                <p className={fontSize}>
                    {`Cały projekt składa się z ${
                        offer.properties
                            ? ` ${offer.properties} ${propertiesPlural(offer.properties)}

                        ${isApartment ? `${apartmentsWhomPlural(offer.properties)}` : `${flatsWhomPlural(offer.properties)}`}`
                            : ""
                    } znajdujących się w ${offer.buildings} ${buildingsPlural(offer.buildings)}. ${buildingsOwnsPlural(offer.buildings)} ${
                        offer.floors_above_ground_range.lower === offer.floors_above_ground_range.upper
                            ? `${offer.floors_above_ground_range.upper} ${floorsAboveGroundPlural(offer.floors_above_ground_range.upper)}`
                            : `od ${offer.floors_above_ground_range.lower} do ${offer.floors_above_ground_range.upper} kondygnacji naziemnych`
                    } wraz z parterem oraz ${
                        offer.floors_below_ground
                            ? `${offer.floors_below_ground} ${floorsBelowGroundPlural(offer.floors_below_ground)}`
                            : `nie ${noFloorsBelowGroundPlural(offer.buildings)} kondygnacji podziemnych`
                    }.`}
                </p>
            )}

            <p>
                {offer.stats?.properties_count_for_sale ? (
                    <>
                        {`Aktualnie w inwestycji ${offer.name} w sprzedaży ${arePlural(offer.stats.properties_count_for_sale)} ${
                            offer.stats.properties_count_for_sale
                        } ${isApartment ? apartmentsWhoPlural(offer.stats.properties_count_for_sale) : flatsWhoPlural(offer.stats.properties_count_for_sale)} ${
                            !!offer.stats.ranges_area_min
                                ? ` o powierzchni${
                                      offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                          ? ` ${offer.stats.ranges_area_min}`
                                          : ` od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                                  } metrów kwadratowych`
                                : ""
                        }${offer.stats.ranges_price_m2_min ? `, w cenie od ${numberFormat(offer.stats.ranges_price_m2_min)} ${getCurrency({currency: props.offer.currency})} za metr kwadratowy` : ""}.`}
                    </>
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych mieszkań w sprzedaży.</>
                )}
            </p>
        </>
    );
};
